import React, { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet";
import Header from "./Header";
import Topsection from "./Topsection";
import Footer from "./Footer";
import FloatingButton from "./FloatingButton";
import Mobilefooterbtn from "./Mobilefooterbtn";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

// const ITEMS_PER_PAGE = 10;

const Batchschedule = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [batchSchedule, setBatchSchedule] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formErrors, setFormErrors] = useState({});

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    course: "",
    days: "",
    location: "",
    startdate: "",
    timings: "",
  });
  const [filters, setFilters] = useState({ course: "", location: "" });
  const swiperRef = useRef(null);

  const locationLinks = {
    "Pune Head Office": "https://g.page/fortunecloud/",
    "Pune Shirodkar Office": "https://g.page/r/CZf_tsH8HKRuEBM/",
    "Pimpri Office": "https://maps.app.goo.gl/fAT129MiX1uhMYRv9/",
    "Bengaluru Office": "https://maps.app.goo.gl/3SbRfZ1DkVCPcPxi6/",
  };

  useEffect(() => {
    const fetchBatchSchedule = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE}/batchschedule/`
        );
        const data = await response.json();
        setBatchSchedule(data);
      } catch (error) {
        console.error("Error fetching Batch Schedule:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBatchSchedule();
  }, []);

  const filteredData = batchSchedule.filter(
    (batch) =>
      batch.course.toLowerCase().includes(filters.course.toLowerCase()) &&
      batch.location.toLowerCase().includes(filters.location.toLowerCase())
  );

  // ✅ Use full filteredData in swiper for desktop
 const featuredBatches = filteredData; // for Swiper
const totalPages = Math.ceil(filteredData.length / 4);
const paginatedMobileBatches = filteredData.slice((currentPage - 1) * 4, currentPage * 4);


  useEffect(() => {
    // Reset to first slide when filtered data changes
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideTo(0);
    }
  }, [filteredData]);

  useEffect(() => {
  setCurrentPage(1);
}, [filters]);


  const openModal = (batch) => {
    setSelectedBatch(batch);
    setFormData({
      ...formData,
      course: batch.course,
      days: batch.days,
      location: batch.location,
      startdate: batch.startdate,
      timings: batch.timings,
    });
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedBatch(null);
  };
  const validateForm = () => {
  const { name, email, contact } = formData;
  const errors = {};

  const nameRegex = /^[A-Za-z\s]{2,}$/;
  if (!nameRegex.test(name)) {
    errors.name = "Enter a valid name (only letters, min 2 chars)";
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    errors.email = "Enter a valid email address";
  }

  const contactRegex = /^[0-9]{10}$/;
  if (!contactRegex.test(contact)) {
    errors.contact = "Enter a valid 10-digit contact number";
  }

  setFormErrors(errors);

  return Object.keys(errors).length === 0;
};

  const handleSubmit = async () => {
    if (!validateForm()) return;
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/demoenquiries/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );
      const result = await response.json();

      if (response.status === 409) {
        alert(
          "A demo enquiry already exists with this email, contact, and course."
        );
      } else if (response.ok) {
        alert("Enquiry submitted!");
        setFormData({
          name: "",
          email: "",
          contact: "",
          course: "",
          days: "",
          location: "",
          startdate: "",
          timings: "",
        });
        closeModal();
      } else {
        alert(result.error || "Failed to submit enquiry");
      }
    } catch (err) {
      console.error(err);
      alert("Error submitting enquiry");
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div>
      <Helmet>
        <title>Fortune Cloud Technologies | Batch Schedule</title>
        <meta
          name="description"
          content="Explore courses and training programs at Fortune Cloud Technologies. Learn with experts and get placed."
        />
      </Helmet>

      <Topsection />
      <Header />

      <div className="container py-4">
        <h2 className="myfont1 fw-bold">Batch Schedule</h2>
        <p className="myfont1">
          Attend our demo sessions — available both online and offline.
        </p>

        <div className="row mb-4">
          <div className="col-md-6 mb-2">
            <input
              type="text"
              className="form-control"
              placeholder="Search by Course"
              value={filters.course}
              onChange={(e) =>
                setFilters({ ...filters, course: e.target.value })
              }
              list="courseOptions"
            />
            <datalist id="courseOptions">
              {[...new Set(featuredBatches.map((batch) => batch.course))].map(
                (course, index) => (
                  <option key={`course-${index}`} value={course} />
                )
              )}
            </datalist>
          </div>
          <div className="col-md-6 mb-2">
            <input
              type="text"
              className="form-control"
              placeholder="Pune | Pimpri | Bengaluru"
              value={filters.location}
              onChange={(e) =>
                setFilters({ ...filters, location: e.target.value })
              }
              list="locationOptions"
            />
            <datalist id="locationOptions">
              {[...new Set(featuredBatches.map((batch) => batch.location))].map(
                (location, index) => (
                  <option key={`location-${index}`} value={location} />
                )
              )}
            </datalist>
          </div>
        </div>

        <h4 className="my-4 fw-bold text-center myfont1">
          🔥 Featured Batches
        </h4>

        {featuredBatches.length > 0 ? (
          <Swiper
            ref={swiperRef}
            effect={"coverflow"}
            grabCursor={true}
            centeredSlides={true}
            loop={true}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            slidesPerView={3} // ✅ Show 3 cards
            breakpoints={{
              320: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1020: { slidesPerView: 3 },
            }}
            coverflowEffect={{
              rotate: 20,
              stretch: 0,
              depth: 150,
              modifier: 1.5,
              slideShadows: false,
            }}
            pagination={false} // ✅ No pagination
            modules={[EffectCoverflow, Pagination, Autoplay]}
            className="mySwiper"
          >
            {filteredData.map((batch, index) => (
              <SwiperSlide key={index}>
                <div className="card shadow-lg border-0 rounded-4 p-4 h-100 bg-light swiper-card d-none d-sm-block">
                  <div className="card-body text-center d-flex flex-column justify-content-between">
                    <div>
                      <h5 className="fw-bold text-primary mb-3">
                        {batch.course}
                      </h5>

                      <p className="mb-2">
                        <i className="bi bi-calendar3 text-secondary me-2"></i>
                        <strong>Start:</strong> {batch.startdate}
                      </p>
                      <p className="mb-2">
                        <i className="bi bi-clock text-secondary me-2"></i>
                        <strong>Timings:</strong> {batch.timings}
                      </p>
                      <p className="mb-2">
                        <i className="bi bi-calendar-week text-secondary me-2"></i>
                        <strong>Days:</strong> {batch.days}
                      </p>
                      <p className="mb-3">
                        <i className="bi bi-geo-alt text-secondary me-2"></i>
                        <strong>Location:</strong>{" "}
                        <a
                          href={locationLinks[batch.location] || "#"}
                          target="_blank"
                          rel="noreferrer"
                          className="text-decoration-none text-dark fw-medium"
                        >
                          {batch.location}
                        </a>
                      </p>
                    </div>

                    <button
                      className="btn btn-primary btn-sm w-100 mt-3"
                      onClick={() => openModal(batch)}
                    >
                      🎯 Get Demo
                    </button>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <div className="text-center py-12">
            <p className="text-gray-500">
              No batches found matching your search.
            </p>
          </div>
        )}
      </div>

      {/* Mobile View (shows first 4 batches with pagination) */}
      <div className="d-block d-sm-none">
        {/* Heading */}
        {/* <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="fw-bold">Latest Batches</h4>
          {featuredBatches.length > 4 && (
            <small className="text-muted">
              Showing {Math.min(currentPage * 4, featuredBatches.length)} of{" "}
              {featuredBatches.length}
            </small>
          )}
        </div> */}

        {/* Batch Cards - Show 4 per page */}
        <div className="row g-3">
          {paginatedMobileBatches.map((batch, index) => (
              <div className="col-12" key={`mobile-${index}`}>
                <div
                  className="card border-0 shadow-sm h-100 overflow-hidden"
                  style={{
                    borderRadius: "12px",
                    borderLeft: "4px solid #0d6efd",
                    transition: "transform 0.2s ease",
                  }}
                >
                  <div className="card-body p-3 d-flex flex-column">
                    {/* Header with course title */}
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <h5
                        className="fw-bold text-dark mb-0"
                        style={{ fontSize: "1.05rem" }}
                      >
                        {batch.course}
                      </h5>
                      <span
                        className="badge bg-primary bg-opacity-10 text-primary"
                        style={{
                          fontSize: "0.7rem",
                          padding: "0.25rem 0.5rem",
                          borderRadius: "4px",
                        }}
                      >
                        New Batch
                      </span>
                    </div>

                    {/* Batch details */}
                    <div className="mt-2">
                      <div className="d-flex align-items-center mb-2">
                        <i
                          className="bi bi-calendar3 text-secondary me-2"
                          style={{ width: "20px" }}
                        ></i>
                        <small className="text-muted">
                          <strong>Starts:</strong> {batch.startdate}
                        </small>
                      </div>

                      <div className="d-flex align-items-center mb-2">
                        <i
                          className="bi bi-clock text-secondary me-2"
                          style={{ width: "20px" }}
                        ></i>
                        <small className="text-muted">
                          <strong>{batch.timings}</strong> ({batch.days})
                        </small>
                      </div>

                      <div className="d-flex align-items-center">
                        <i
                          className="bi bi-geo-alt text-secondary me-2"
                          style={{ width: "20px" }}
                        ></i>
                        <small className="text-muted">
                          <a
                            href={locationLinks[batch.location] || "#"}
                            target="_blank"
                            rel="noreferrer"
                            className="text-decoration-none text-dark"
                          >
                            {batch.location}
                          </a>
                        </small>
                      </div>
                    </div>

                    {/* CTA Button */}
                    <button
                      className="btn btn-primary w-100 mt-3 py-2"
                      style={{
                        borderRadius: "8px",
                        fontSize: "0.9rem",
                        fontWeight: "500",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      }}
                      onClick={() => openModal(batch)}
                    >
                      <i className="bi bi-calendar-check me-2"></i>Get Free Demo
                    </button>
                  </div>
                </div>
              </div>
            ))}
        </div>
        {/* Pagination Controls */}
        {featuredBatches.length > 4 && (
          <div className="d-flex justify-content-center mt-4">
            <nav aria-label="Batch pagination">
              <ul className="pagination pagination-sm">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(prev - 1, 1))
                    }
                  >
                    Previous
                  </button>
                </li>

                {[...Array(totalPages).keys()].map(
                  (num) => (
                    <li
                      key={num}
                      className={`page-item ${
                        currentPage === num + 1 ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage(num + 1)}
                      >
                        {num + 1}
                      </button>
                    </li>
                  )
                )}

                <li
                  className={`page-item ${
                    currentPage * 4 >= filteredData.length ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() =>
                      setCurrentPage((prev) =>
                        Math.min(
                          prev + 1,
                          Math.ceil(featuredBatches.length / 4)
                        )
                      )
                    }
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </div>

      {/* Modal */}
      {modalOpen && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          role="dialog"
        >
          <div
            className="modal-dialog modal-dialog-centered modal-sm"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {selectedBatch?.course} - {selectedBatch?.timings}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <input
                  name="name"
                  placeholder="Your Name"
                  className="form-control mb-2"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                {formErrors.name && <div style={{ color: "red", fontSize: "0.875rem" }}>{formErrors.name}</div>}
                <input
                  name="email"
                  type="email"
                  placeholder="Your Email"
                  className="form-control mb-2"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                {formErrors.email && <div style={{ color: "red", fontSize: "0.875rem" }}>{formErrors.email}</div>}
                <input
                  name="contact"
                  type="tel"
                  placeholder="Your Contact"
                  className="form-control mb-2"
                  value={formData.contact}
                  onChange={handleChange}
                  required
                />
              </div>
              {formErrors.contact && <div style={{ color: "red", fontSize: "0.875rem" }}>{formErrors.contact}</div>}
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={closeModal}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handleSubmit}>
                  Submit Request
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
      <FloatingButton />
      <Mobilefooterbtn />
    </div>
  );
};

export default Batchschedule;
